import type { paths } from "@ala/codegen/account-service-api-schema.ts";
import { Api } from "@ala/core/constants";
import { useHttpClientFactory, useHttpClientSWR, useHttpClientSWRMutation } from "@ala/core/http-client";

export const useUser = () => {
  const client = useHttpClientFactory<paths>(Api.Account, { tenantId: "" });
  const { error, data, isLoading, isValidating, mutate: invalidate } = useHttpClientSWR(client, "/users/me", "get", {});

  if (error || data?.error) return null;
  return { data: data?.response.body, isLoading, isValidating, invalidate };
};

export const useUserMutation = () => {
  return useHttpClientSWRMutation<paths, "/users/me", "get">("/users/me", {});
};
